import {Component} from '@angular/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ObservationTypeDialogData} from '../../../../../../shared/models/observation-type';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-create-observation-type-dialog',
  templateUrl: 'create-observation-type-dialog.component.html',
  styleUrls: ['create-observation-type-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ]
})
export class CreateObservationTypeDialogComponent {

  public data: ObservationTypeDialogData = {} as ObservationTypeDialogData;

  constructor(
    public dialogRef: MatDialogRef<CreateObservationTypeDialogComponent>) {
  }
}
